import { AddShopOrdersToBatchDataGridApi } from "src/api/generated/erp/production/shopOrderBatch/api/addShopOrdersToBatchDataGridApi.ts";
import i18n from "i18next";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { faLink } from "@fortawesome/pro-regular-svg-icons";
import {
	AddShopOrdersToBatchDataGridBase,
	AddShopOrdersToBatchDataGridBaseProps,
} from "src/components/views/erp/production/shopOrderBatch/AddShopOrdersToBatchDataGridBase.tsx";
import { ShopOrderBatchUpdateAttributesMenuButton } from "src/components/views/erp/production/shopOrderBatch/ShopOrderBatchUpdateAttributesMenuButton.tsx";

export interface AddShopOrdersToBatchDataGridProps extends Omit<
	AddShopOrdersToBatchDataGridBaseProps,
	"actionBarComponents" | "rowContextMenuComponents" | "shopOrderBatchId"
> {
	shopOrderBatchId?: number;
	onCompleted?: () => Promise<unknown>;
}

export const AddShopOrdersToBatchDataGrid = (props: AddShopOrdersToBatchDataGridProps) => {
	const { shopOrderBatchId, defaultProductionLineId, onCompleted, ...other } = props;

	return (
		<AddShopOrdersToBatchDataGridBase
			defaultProductionLineId={defaultProductionLineId}
			shopOrderBatchId={shopOrderBatchId}
			actionBarComponents={({ selectedRows }) => (
				<>
					{shopOrderBatchId && (
						<AsyncButton
							label={i18n.t("connect_selected")}
							icon={faLink}
							variant={"outlined"}
							onClick={async () => {
								await AddShopOrdersToBatchDataGridApi.addSelectedRowsToBatch({
									shopOrderBatchId: shopOrderBatchId,
									selectedShopOrderIds: selectedRows.map((r) => r.shopOrderId),
								});
								await onCompleted?.();
							}}
						/>
					)}
				</>
			)}
			rowContextMenuComponents={({ row, allSelectedRows, refreshData }) => [
				<ShopOrderBatchUpdateAttributesMenuButton
					key={"updateAttributes"}
					shopOrderBatchId={shopOrderBatchId}
					row={row}
					allSelectedRows={allSelectedRows}
					onAttributesUpdated={refreshData}
				/>,
			]}
			{...other}
		/>
	);
};
